import { apiClient } from './client';
import type { ApiKeyCreateRequest, ApiKeyCreatedResponse, ApiKeyResponse } from './types';

export const apiKeysApi = {
  /** Every key in the active workspace, revoked ones included, newest first. */
  list: async (): Promise<ApiKeyResponse[]> => {
    const response = await apiClient.get('/api-keys');
    return response.data;
  },

  /** Mint a key. The response's `key` is the only time the plaintext exists. */
  create: async (data: ApiKeyCreateRequest): Promise<ApiKeyCreatedResponse> => {
    const response = await apiClient.post('/api-keys', data);
    return response.data;
  },

  /** Revoke immediately. Idempotent on the backend. */
  revoke: async (id: string): Promise<void> => {
    await apiClient.delete(`/api-keys/${encodeURIComponent(id)}`);
  },
};
